export const SYNC_TWR_CHANNEL = '@@myDevices/twrChannelSync'
export const SYNC_TWR_CHANNEL_SENT = '@@myDevices/twrChannelSyncSent'
export const OPEN_TWR_CHANNEL = '@@myDevices/twrChannelOpen'
export const CLOSE_TWR_CHANNEL = '@@myDevices/twrChannelClose'
export const SET_RESPONSE_FROM_TWR_CHANNEL = '@@myDevices/setResponseFromTwrChannel'
